import { Flex, Text } from "@chakra-ui/react"
import { INormalizedChangeItem } from "types/laundry"
import ChangeListItem from "../ChangeListItem"
import { IChnageListProps } from "./ChangeListTypes"

const ChangeList: React.FC<IChnageListProps> = ({ items, title, isCurrent }) => {
  return (

    <Flex w="100%" flexDirection={"column"}>
      <Text mb={"15px"} mt={"15px"} fontSize="base">{title}</Text>
      <Flex borderRadius={"10px"} p={"16px"} flexDirection={"column"} backgroundColor={isCurrent ? "#E6F8EB" : "#d4d5d6"} >
        {items.map((item: INormalizedChangeItem, i: number) => (
          <ChangeListItem isCurrent={isCurrent!} key={item.field} title={item.field} value={item.value || ""} type={item.type} typeId={item.typeId} />
        ))}
      </Flex>
    </Flex>
  )
}

export default ChangeList